"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mondragone": {
    "425a4ee4": [{
      "hkey": "9294ff53",
      "slug": "crocelle-san-nicola-sant-angelo",
      "name": "Crocelle-San Nicola-Sant'Angelo",
      "primary": true,
      "skipSearch": false
    }],
    "crocelle": [{
      "hkey": "9294ff53",
      "slug": "crocelle-san-nicola-sant-angelo",
      "name": "Crocelle-San Nicola-Sant'Angelo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a13e1b31": [{
      "hkey": "1446db6c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "piazza": [{
      "hkey": "1446db6c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2c8c77b5": [{
      "hkey": "1446db6c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "porta-di-mare": [{
      "hkey": "1446db6c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "mondragone"
    }],
    "56b14ada": [{
      "hkey": "9294ff53",
      "slug": "crocelle-san-nicola-sant-angelo",
      "name": "Crocelle-San Nicola-Sant'Angelo",
      "primary": true,
      "skipSearch": false
    }],
    "san-nicola": [{
      "hkey": "9294ff53",
      "slug": "crocelle-san-nicola-sant-angelo",
      "name": "Crocelle-San Nicola-Sant'Angelo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "mondragone"
    }],
    "148fa643": [{
      "hkey": "9294ff53",
      "slug": "crocelle-san-nicola-sant-angelo",
      "name": "Crocelle-San Nicola-Sant'Angelo",
      "primary": true,
      "skipSearch": false
    }],
    "sant-angelo": [{
      "hkey": "9294ff53",
      "slug": "crocelle-san-nicola-sant-angelo",
      "name": "Crocelle-San Nicola-Sant'Angelo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "mondragone"
    }]
  }
};
exports["default"] = _default;